"use client";

import React from "react";

import { numberPhoneStringToFrenchFormat } from "@/app/(main)/(club)/mes-clubs/[id]/membres/_utils";
import ProfilePicture from "@/components/user/profile-picture";

interface PresidentTitleProps {
  president: {
    firstName?: string;
    lastName?: string;
    avatar?: { urls?: { avatar_md?: string } };
    phone?: { number?: string };
    email?: string;
  };
  clubName?: string;
}

export default function PresidentTitle(props: PresidentTitleProps) {
  return (
    <div className={"flex items-center gap-4"}>
      <ProfilePicture
        src={props.president?.avatar?.urls?.avatar_md}
        firstName={props.president?.firstName}
        lastName={props.president?.lastName}
        className={"md:max-w-16 md:min-w-16 md:min-h-16 md:max-h-16 mr-4"}
        size={64}
      />
      <div>
        <h4>
          Présidé par{" "}
          <span className={"font-bold"}>
            {props.president?.firstName}{" "}
            <span className={"uppercase"}>{props.president?.lastName}</span>
          </span>
        </h4>
        <div>
          Club {" : "} {props.clubName}
        </div>
        <div className={"flex-col gap-x-7 mt-3 flex-wrap"}>
          {props.president?.phone && (
            <p>
              <b>Tél. :</b>{" "}
              {numberPhoneStringToFrenchFormat(
                `0${props.president?.phone.number}`,
              )}
            </p>
          )}
          {props.president.email && (
            <p>
              <b>E-mail : </b>
              <span className={"underline"}>{props.president.email}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
